module.exports = __webpack_public_path__ + "static/media/host-game-setting.2bbcb660.gif";